import * as React from 'react';
const OnicomicosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M84.47 68.43c3.6 1.84 5.73 5.49 5.73 10.69 0 7.75-3.19 10.74-3.38 12.05s-.18 2.18.61 2.76c.8.58 5.22 1.38 5.22 1.38M77.91 93.48c-4.16 0-8.79-3.27-11.08-7.96M89.89 73.8c1.64-1.32 6.5-3.33 9.67-2.11s5.93 4.1 4.81 7.71-3.67 11.14-4.02 12.94c-.36 1.8.33 2.85.86 3.59s3.17 1.9 3.17 1.9"
      className="prefix__cls-2"
    />
    <path
      d="M104.05 81.41c1.43-1.15 5.68-2.91 8.44-1.85 2.77 1.06 5.18 3.58 4.2 6.74s-3.2 9.74-3.52 11.3c-.31 1.57.29 2.49.75 3.14s2.77 1.66 2.77 1.66"
      className="prefix__cls-2"
    />
    <path
      d="M117.11 86.53c1.3-.84 4.8-1.56 7.02-.42s3.7 3.8 2.78 6.55-2.37 6.27-2.78 7.43-.35 1.61-.23 2.79 1.17 2.57 1.17 2.57"
      className="prefix__cls-2"
    />
    <path
      d="M135.54 130.81c.46-2.46.73-4.67.73-6.51 0-10.53-1.58-11.89-2.69-13.46s-1.28-3.25-.87-5.06c.41-1.82 2.75-3.49 2.5-6.46s-2.37-4.03-4.19-4.36c-1.82-.34-4.48.37-4.48.37M69.17 90.31c0 4.77-4.32 8.42-4.32 20.29 0 9 1.88 17.02 4.23 24.17"
      className="prefix__cls-2"
    />
    <circle cx={71.57} cy={73.07} r={7.84} className="prefix__cls-1" />
    <circle cx={71.57} cy={73.07} r={1.12} className="prefix__cls-1" />
  </svg>
);
export default OnicomicosiIcon;
